import React, {Fragment, useEffect, useState} from 'react';
import {
    Card,
    Table,
    Menu,
    Dropdown,
    Space,
    Input,
    Row,
    Button,
    Typography,
    Modal,
    Form,
    Select,
    Checkbox,
    TimePicker,
    InputNumber,
    notification,
    Popover, Switch, Divider
} from "antd";

import {DownOutlined, DownloadOutlined, DeleteOutlined, PlusOutlined, InfoCircleOutlined} from '@ant-design/icons';

import ApiService from "../../services/ApiService"
import {MiddleSelect} from "antd/es/pagination/Select";
import IntlMessage from "../util-components/IntlMessage";
import TextArea from "antd/es/input/TextArea";
import {useSelector} from "react-redux";
import {getDevise} from "../permissions/functions";
import MultiAssocForm from "./MultiAssocForm";


const {Search} = Input;
const {Text} = Typography;
const {Option} = Select;


export default function MultiAssocForm2(props) {
    return (
        <MultiAssocForm {...props}/>
    )
}

